import { parseUrl } from '../utils/url'
import { readCookie } from '../utils/cookies'

import {
  IS_PROD,
  IS_SANDBOX,
  IS_WEB,
  CONSOLE_URL,
  COOKIES_TRACKING_CONSENT_COOKIE_NAME
} from '../config/'

const HUBSPOT_ID = '3948389'

const DEFAULT_EVENT_TRACKING_CONFIG = {
  trackOnMixpanel: true,
  trackOnGa: true
}
const DEFAULT_PAGE_TRACKING_CONFIG = {
  trackOnMixpanel: true,
  trackOnGa: true
}

// modified later - check for user consent to tracking (in cookie, otherwise after user
// interacts with CookiesAndAnalyticsInfo banner)
let trackingSettings = {
  disabled: true
}

function loadScript (src, id) {
  const scriptTag = window.document.createElement('script')
  var existingScriptTag = window.document.getElementsByTagName('script')[0]
  if (!existingScriptTag) {
    console.log('no script tags in page? cannot load script')
    return
  }
  scriptTag.async = 1
  scriptTag.defer = 1
  if (id) {
    scriptTag.id = id
  }
  scriptTag.src = src
  existingScriptTag.parentNode.insertBefore(scriptTag, existingScriptTag)
}
// AFTER the user has given consent!
function loadTrackingScripts () {
  if (!(IS_WEB && IS_PROD && !IS_SANDBOX)) {
    return
  }
  loadScript('https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js')
  loadScript('https://www.google-analytics.com/analytics.js')
  loadScript(`https://js.hs-scripts.com/${HUBSPOT_ID}.js`)
}

// called at init
function checkEnableTrackingEnabledCookie () {
  const storedCookie = readCookie(COOKIES_TRACKING_CONSENT_COOKIE_NAME)
  if (storedCookie) {
    try {
      const parsedCookie = JSON.parse(storedCookie)
      // user has given consent to use analytics
      if (parsedCookie && parsedCookie.analytics) {
        loadTrackingScripts()
        trackingSettings.disabled = false
      }
    } catch (e) {
      console.log('failed to parse cookie', e)
    }
  }
}
checkEnableTrackingEnabledCookie()

export function enableTracking () {
  if (trackingSettings.disabled) {
    console.log('enabling analytics..')
    loadTrackingScripts()
    trackingSettings.disabled = false
  }
}

// can only be called from web!
export function doNotTrackEnabled () {
  return (
    window.navigator.doNotTrack === '1' || window.navigator.doNotTrack === true
  )
}

// used for tracking purposes - when we're moving to a different domain.
// f.e. snips.ai -> console.snips.ai
// as mixpanel would otherwise lose track of the user
export function addTrackingParams (url) {
  if (!IS_WEB) {
    return url
  }
  let mxd
  // if we have a separate sdk instance of mixpanel, use that.
  // means user came from a different snips site, and we've continued to follow them.
  if (
    window.mixpanel &&
    window.mixpanel.sdk &&
    window.mixpanel.sdk.get_distinct_id
  ) {
    mxd = window.mixpanel.sdk.get_distinct_id()
  } else if (window.mixpanel && window.mixpanel.get_distinct_id) {
    // otherwise, pass along the mixpanel distinct id set on this site
    mxd = window.mixpanel.get_distinct_id()
  }
  if (!mxd) {
    return url
  }
  let parsedUrl = parseUrl(url)
  parsedUrl.search +=
    (parsedUrl.search ? '&' : '?') + `mxd=${encodeURIComponent(mxd)}`
  return parsedUrl.href
}

export function trackThenLeaveToDevConsole (e, context) {
  e.preventDefault()
  trackEvent('DevConsole', context)
  // arbitrary time to wait until this action has been tracked,
  // before leaving the page
  setTimeout(() => {
    window.location = addTrackingParams(CONSOLE_URL)
  }, 250)
}

export function trackEvent (value, extra, config) {
  const { trackOnMixpanel, trackOnGa } = Object.assign(
    {},
    DEFAULT_EVENT_TRACKING_CONFIG,
    config
  )
  if (!IS_PROD) {
    console.info('DEV::trackEvent', {
      value,
      extra,
      disabled: trackingSettings.disabled
    })
    return
  }
  if (trackingSettings.disabled) {
    return
  }
  if (trackOnGa && window.ga) {
    window.ga('send', 'event', 'Click', value, extra, { nonInteraction: true })
  }
  if (trackOnMixpanel && window.mixpanel && window.mixpanel.track) {
    window.mixpanel.track(value, { extra: extra })
  }
  window['optimizely'] = window['optimizely'] || []
  window.optimizely.push(['trackEvent', value])
}

export function trackPageView (config) {
  const { trackOnMixpanel, trackOnGa } = Object.assign(
    {},
    DEFAULT_PAGE_TRACKING_CONFIG,
    config
  )
  const pathname = window.location.pathname
  if (!IS_PROD) {
    console.info('DEV::trackPageView', {
      pathname,
      disabled: trackingSettings.disabled
    })
    return
  }
  if (trackingSettings.disabled) {
    return
  }
  // not available  on staging
  if (trackOnGa && window.ga) {
    window.ga('set', 'page', pathname)
    window.ga('send', 'pageview')
  }

  // send _all_ page views to the sdk project on mixpanel
  // so we can use it for funnels.
  // NOTE: this is quite a lof of events (data points)
  // - might make sense to only send the page people land on;
  // or just sending events during campaigns..
  if (trackOnMixpanel && window.mixpanel.sdk && window.mixpanel.sdk.track) {
    window.mixpanel.sdk.track('pageView', {
      pageName: document.title,
      url: window.location.href
    })
  }

  // hubspot
  var _hsq = (window._hsq = window._hsq || [])
  _hsq.push(['trackPageView'])
}

export function trackException (e) {
  if (trackingSettings.disabled || !window.ga || !e) {
    return
  }
  window.ga('send', 'exception', {
    exDescription:
      'JavaScript Error ' + e.message + ' ' + e.filename + ': ' + e.lineno
  })
}



// WEBPACK FOOTER //
// ./frontend/scripts/utils/tracking.js